import React from "react";

const EmailIcon = ({ width, height, color }) => {
  return (
    <svg
      width="45"
      height="33"
      viewBox="0 0 49 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 35L2 2L47 2L47 35L2 35Z" stroke="#435CFF" strokeWidth="3" />
      <path
        d="M47 2L27.2706 21.9044C25.8083 23.3716 23.1473 23.3543 21.7158 21.9178L2 2.1602"
        stroke="#435CFF"
        strokeWidth="3"
      />
      <path d="M46 35L31 19" stroke="#435CFF" strokeWidth="3" />
      <path d="M3 34L18 19" stroke="#435CFF" strokeWidth="3" />
    </svg>
  );
};

export default EmailIcon;
